import { useCallback, useMemo } from 'react';
import { Tooltip } from 'react-leaflet';
import { Icon } from 'leaflet';
import { AssetSidePanelTab, openSidePanel, SidePanel } from '@customer/store/slices/globalSlice';
import { useAppDispatch } from '@customer/store/hooks';
import { IconDozer, IconLvWhite } from '../icons';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import { RotationModel } from '../utils';

export interface AssetMarkerProps extends RotationModel {
  id: number;
  name: string;
  hardwareType: number;
}

export function AssetMarker({ id, name, position, heading, hardwareType }: AssetMarkerProps) {
  const dispatch = useAppDispatch();

  const markerIcon = useMemo<Icon>(() => {
    switch (hardwareType) {
      case 3:
      case 4:
        return new IconDozer();

      default:
        return new IconLvWhite();
    }
  }, [hardwareType]);

  const onClicked = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.Asset,
        modelId: id.toString(),
        tab: AssetSidePanelTab.Details,
      }),
    );
  }, [dispatch, id]);

  return (
    <RotatableMarker
      icon={markerIcon}
      position={position}
      heading={heading}
      eventHandlers={{ click: onClicked }}
    >
      <Tooltip className="tooltip-override" permanent>
        {name}
      </Tooltip>
    </RotatableMarker>
  );
}

export default AssetMarker;
